import { ChangeDetectionStrategy, Component, Input } from '@angular/core'

import { Required } from '@app/core/decorators/required'
import { Confirmable } from '@ui/models/confirmable'
import { UIModule } from '@ui/ui.module'

@Component({
  selector: 'sb-message-photo-album-rules-modal',
  templateUrl: './message-photo-album-rules-modal.component.html',
  imports: [UIModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessagePhotoAlbumRulesModalComponent extends Confirmable {
  @Required @Input() cost: number | undefined
}
